import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { reduxForm } from 'redux-form'

import { Button, Notification } from '@offerzen/pinata-shame'

import { previousOnboardingUrl } from '../../helpers/onboardingSteps'
import CardFooterNav from '../../components/CardFooterNav'

import styles from './styles'

const EducationList = ({ addBlankEducation, children, ...props }) => (
  <React.Fragment>
    <p className={styles.description}>
      Add the high school certificates, degrees, diplomas, and professional or course certifications you’ve earned.
    </p>

    <div>{children}</div>

    <Button label="Add education" variant="outlined" size="medium" theme="primary" onClick={() => addBlankEducation()} />

    <form onSubmit={props.handleSubmit}>
      <If condition={props.error}>
        <Notification theme="error" className={styles.notice}>
          {props.error}
        </Notification>
      </If>

      <CardFooterNav
        navigateBack={() => props.history.push(previousOnboardingUrl(props.location.pathname))}
        loading={props.submitting}
        className={styles.footer}
      />
    </form>
  </React.Fragment>
)

EducationList.propTypes = {
  addBlankEducation: PropTypes.func,
  children: PropTypes.node,
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  submitting: PropTypes.bool,
}

export default withRouter(
  reduxForm({
    form: 'educationListForm',
    onSubmit: (values, _, props) => new Promise((resolve, reject) => props.submitEducation(values, resolve, reject)),
  })(EducationList),
)
